<template>
  <d-card class="card-small h-100">

    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
      <div class="block-handle"></div>
    </d-card-header>

    <d-card-body class="pt-0">
      <d-row class="border-bottom py-2 bg-light">

        <!-- Date Range -->
        <!-- <d-col col sm="6" class="d-flex mb-2 mb-sm-0">
          <d-input-group size="sm" class="date-range d-flex justify-content-left">
            <d-datepicker v-model="dateRange.from" :highlighted="{ from: dateRange.from, to: dateRange.to || new Date() }" placeholder="Start Date" typeable small />
            <d-datepicker v-model="dateRange.to" :highlighted="{ from: dateRange.from, to: dateRange.to || new Date() }" placeholder="End Date" typeable small />
            <d-input-group-text slot="append">
              <i class="material-icons">&#xE916;</i>
            </d-input-group-text>
          </d-input-group>
        </d-col> -->

        <!-- View Full Report -->
        <!-- <d-col col sm="6">
          <d-button size="sm" class="d-flex btn-white ml-auto mr-auto ml-sm-auto mr-sm-0 mt-3 mt-sm-0">View Full Report &rarr;</d-button>
        </d-col> -->

      </d-row>

      <!-- Legend & Chart -->
      <div ref="legend"></div>
        <div id="Noofapprovals"></div>
      <!-- <canvas height="120" ref="canvas" style="max-width: 100% !important;"></canvas> -->

    </d-card-body>
  </d-card>
</template>

<script>
import Chart from '../../utils/chart';

const defaultChartData = {
  labels: Array.from(new Array(30), (_, i) => (i === 0 ? 1 : i)),
  datasets: [{
    label: 'Onion',
    fill: 'start',
    data: [500, 800, 320, 180, 240, 320, 230, 650, 590, 1200, 750, 940, 1420, 1200, 960, 1450, 1820, 2800, 2102, 1920, 3920, 3202, 3140, 2800, 3200, 3200, 3400, 2910, 3100, 4250],
    backgroundColor: 'rgba(0,123,255,0.1)',
    borderColor: 'rgba(0,123,255,1)',
    pointBackgroundColor: '#ffffff',
    pointHoverBackgroundColor: 'rgb(0,123,255)',
    borderWidth: 1.5,
    pointRadius: 0,
    pointHoverRadius: 3,
  }, {
    label: 'Garlic',
    fill: 'start',
    data: [380, 430, 120, 230, 410, 740, 472, 219, 391, 229, 400, 203, 301, 380, 291, 620, 700, 300, 630, 402, 320, 380, 289, 410, 300, 530, 630, 720, 780, 1200],
    backgroundColor: 'rgba(255,65,105,0.1)',
    borderColor: 'rgba(255,65,105,1)',
    pointBackgroundColor: '#ffffff',
    pointHoverBackgroundColor: 'rgba(255,65,105,1)',
    borderDash: [3, 3],
    borderWidth: 1,
    pointRadius: 0,
    pointHoverRadius: 2,
    pointBorderColor: 'rgba(255,65,105,1)',
  }],
};

export default {
  name: 'users-overview',
  props: {
    title: {
      type: String,
      default: 'Overview',
    },
    chartData: {
      type: Object,
      default() {
        return defaultChartData;
      },
    },
  },
  data() {
    return {
      dateRange: {
        from: null,
        to: null,
      },

      Noofapprovalsoptions: {
                series: [{
                        name: "Onion price",
                        data: [8, 9, 8, 9, 10, 9, 11, 10,8]
                    },
                    {
                        name: "Garlic price",
                        data: [69, 65, 62, 66, 70, 72, 70, 71,77]
                    },
                    {
                        name: "Ginger price",
                        data: [12, 30, 35, 32, 28, 25, 30, 29,38]
                    },
                         {
                        name: "Potato price",
                        data: [20, 28, 23, 23, 27, 23, 20, 25, 28]
                    },

                ],
                chart: {
                    id: 'Noofapprovals',
                    height: 350,
                    type: 'line',
                        toolbar: {
                              show: true,
                              offsetX: 10,
                              offsetY: 10,
                              tools: {
                                download: true,
                                selection: true,
                                zoom: true,
                                zoomin: true,
                                zoomout: true,
                                pan: true,
                                reset: true | '<img src="/static/icons/reset.png" width="20">',
                                customIcons: []
                              },
                              autoSelected: 'zoom'
                          },
                    zoom: {
                        enabled: false
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {


                },
                title: {
                    //text: 'Page Statistics',
                    align: 'left'
                },
                legend: {
                    tooltipHoverFormatter: function (val, opts) {
                        return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '.00 Rs Pre kg'
                    }
                },
                markers: {
                    size: 4,
                    hover: {
                        sizeOffset: 3
                    }
                },
                xaxis: {
                    categories: ['17 Jun','18 Jun', '19 Jun', '20 Jun', '21 Jun', '22 Jun', '23 Jun', '24 Jun', '25 Jun'],
                },
                tooltip: {
                    y:  {
                            title: {
                                formatter: function (val) {
                                    return val
                                }
                            }
                        },

                },
                grid: {
                    borderColor: '#f1f1f1',
                }
            },

    };
  },
  mounted() {
    let vm =this;
          var Noofapprovals = new ApexCharts(document.querySelector("#Noofapprovals"), vm.Noofapprovalsoptions);
          Noofapprovals.render();

    const BlogUsersOverview = new Chart(this.$refs.canvas, {
      type: 'LineWithLine',
      data: this.chartData,
      options: chartOptions,
    });

      // They can still be triggered on hover.
    const buoMeta = BlogUsersOverview.getDatasetMeta(0);
    buoMeta.data[0]._model.radius = 0;
    buoMeta.data[this.chartData.datasets[0].data.length - 1]._model.radius = 0;

    // Render the chart.
    BlogUsersOverview.render();
  },
};
</script>

